<template>
  <div>
    <!--<LaunchAppTop v-if="!$isElectron && $isMobile() && memo.slug" :slug="memo.slug" />-->
    <div class="thread">
      <div
        class="header"
        :style="{
          padding: $isElectron ? '40px 0' : '10px 0',
        }"
      >
        <!-- <i class="el-icon-arrow-down close"></i> -->
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="closeClicked"
          style="cursor: pointer"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.954 0.849705C14.0332 0.928666 14.096 1.02247 14.1388 1.12574C14.1817 1.22901 14.2037 1.33972 14.2037 1.45153C14.2037 1.56334 14.1817 1.67405 14.1388 1.77732C14.096 1.88059 14.0332 1.97439 13.954 2.05335L2.05352 13.9538C1.8939 14.1134 1.67742 14.2031 1.45169 14.2031C1.22597 14.2031 1.00948 14.1134 0.849869 13.9538C0.690256 13.7942 0.600586 13.5777 0.600586 13.352C0.600586 13.1263 0.690256 12.9098 0.849869 12.7502L12.7503 0.849705C12.8293 0.770544 12.9231 0.707739 13.0264 0.664886C13.1296 0.622033 13.2404 0.599976 13.3522 0.599976C13.464 0.599976 13.5747 0.622033 13.678 0.664886C13.7812 0.707739 13.875 0.770544 13.954 0.849705Z"
            fill="#9D9D9D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.849827 0.849705C0.770666 0.928666 0.707861 1.02247 0.665008 1.12574C0.622155 1.22901 0.600098 1.33972 0.600098 1.45153C0.600098 1.56334 0.622155 1.67405 0.665008 1.77732C0.707861 1.88059 0.770666 1.97439 0.849827 2.05335L12.7503 13.9538C12.9099 14.1134 13.1264 14.2031 13.3521 14.2031C13.5778 14.2031 13.7943 14.1134 13.9539 13.9538C14.1136 13.7942 14.2032 13.5777 14.2032 13.352C14.2032 13.1263 14.1136 12.9098 13.9539 12.7502L2.05347 0.849705C1.97451 0.770544 1.88071 0.707739 1.77744 0.664886C1.67417 0.622033 1.56346 0.599976 1.45165 0.599976C1.33984 0.599976 1.22913 0.622033 1.12586 0.664886C1.02259 0.707739 0.928788 0.770544 0.849827 0.849705Z"
            fill="#9D9D9D"
          />
        </svg>

        <h2>{{ $t('thread.detail') }}</h2>
        <span></span>
      </div>
      <memo
        :memo="memo"
        :menu_thread_hidden="true"
        :backlink_hidden="true"
        :http_direct="http_direct"
        v-on:tag-clicked="tagClicked"
        v-on:memo-updated="updatedMemo"
        v-on:memo-removed="removeMemo"
        v-on:open-thread="openThread"
        v-on:share-clicked="shareClicked"
        v-on:add-linked-memo="addLinkedMemo"
        v-on:memo-editing="memoEditing"
        :is_Thread="true"
      ></memo>
      <div class="replies" v-if="memo.backlinked_memos && memo.backlinked_memos.length">
        <p>
          {{
            $t('thread.backlinked_title', {
              backlinked_count: memo.backlinked_memos.length,
            })
          }}
          <label class="pro" v-if="!$store.getters.is_pro">PRO</label>
        </p>
        <div v-if="$store.getters.is_pro">
          <div class="reply" v-for="backlinked_memo in memo.backlinked_memos" v-bind:key="backlinked_memo.slug">
            <memo
              :memo="backlinked_memo"
              :http_direct="http_direct"
              v-on:tag-clicked="tagClicked"
              v-on:memo-removed="removeReply"
              v-on:memo-updated="updatedReply"
              v-on:open-thread="openThread"
              v-on:share-clicked="shareClicked"
              v-on:add-linked-memo="addLinkedMemo"
            ></memo>
          </div>
        </div>
        <div v-if="!$store.getters.is_pro">
          <div class="reply">
            <memo
              :memo="memo.backlinked_memos[0]"
              :http_direct="http_direct"
              v-on:tag-clicked="tagClicked"
              v-on:memo-removed="removeReply"
              v-on:memo-updated="updatedReply"
              v-on:open-thread="openThread"
              v-on:share-clicked="shareClicked"
              v-on:add-linked-memo="addLinkedMemo"
            ></memo>
          </div>
        </div>
        <div class="reply limited" v-if="memo.backlinked_memos.length >= 2 && !$store.getters.is_pro">
          <div class="reply-card">
            {{ $t('thread.pro_needed_1') }}<span @click="clickMembership">{{ $t('thread.pro_needed_2') }}</span>
          </div>
        </div>
      </div>
    </div>
    <LaunchAppBottom v-if="!$isElectron && $isMobile() && memo.slug" :slug="memo.slug" />
  </div>
</template>
<script>
import Memo from '../components/Memo.vue'
import DBUtil from '../utils/DBUtil'
import api from '../../api'
import emitter from '../utils/eventbus.js'
//import LaunchAppTop from '../components/LaunchAppTop.vue'
import LaunchAppBottom from '../components/LaunchAppBottom'

export default {
  components: {
    Memo,
    //LaunchAppTop,
    LaunchAppBottom,
  },
  data() {
    return {
      me: this.$store.state.me,
      loading: false,
      http_direct: false,
      memo: {},
      isEditing: false,
      is_mobile: this.$isMobile() || document.body.clientWidth <= 640,
    }
  },
  methods: {
    memoEditing(isEditing) {
      this.isEditing = isEditing
    },
    loadMemo(memo_id, http_direct) {
      if (!memo_id) {
        return
      }
      console.log('thread loadMemo', memo_id)
      this.memo = {}
      this.loading = true
      let vm = this
      this.http_direct = http_direct

      if (this.http_direct) {
        vm.getMemoDetailByHttp(memo_id)
      } else {
        this.http_direct = false
        DBUtil.getMemo(memo_id, true).then(function (memo) {
          if (memo == undefined) {
            vm.http_direct = true
            vm.getMemoDetailByHttp(memo_id)
          } else {
            vm.memo = memo
            vm.loading = false
            vm.http_direct = false
          }
        })
      }
    },
    getMemoDetailByHttp(memo_id) {
      api.call('GET', '/memo/' + memo_id, {}, (response) => {
        this.loading = false
        if (response.data && response.data.code === -1) {
          this.closeClicked()
        } else if (response.data && response.data.code === 0) {
          this.memo = response.data.data
        }
      })
    },
    removeMemo(memo) {
      this.$emit('memo-removed', memo)
      this.$emit('close-clicked')
    },
    closeClicked() {
      this.$emit('close-clicked')
    },
    tagClicked(tag) {
      if (this.isEditing) return
      this.$store.commit('setStartDate', null)
      this.$store.commit('setEndDate', null)
      this.$store.commit('setSelectedSource', null)
      this.$store.commit('setSelectedTag', null)
      this.$store.commit('setType', null)
      this.$store.commit('setSelectedTag', tag.trim())
      this.$emit('tag-clicked', tag)
    },
    removeReply(reply) {
      this.memo.backlinked_memos.splice(this.memo.backlinked_memos.indexOf(reply), 1)
      // this.memo.backlinked_count -= 1;
    },
    updatedReply(reply) {
      let index
      for (let i = 0; i < this.memo.backlinked_memos.length; i++) {
        const _reply = this.memo.backlinked_memos[i]
        if (_reply.id === reply.id) {
          index = i
          if (_reply.backlinked_memos) reply.backlinked_memos = _reply.backlinked_memos
          break
        }
      }
      this.$set(this.memo.backlinked_memos, index, reply)
    },
    updatedMemo(memo) {
      this.memo.content = memo.content
    },
    openThread(_memo) {
      if (this.isEditing) return
      this.$emit('thread-clicked', _memo)
    },
    shareClicked(memo) {
      this.$emit('share-clicked', memo)
    },
    clickMembership() {
      this.closeClicked()
      this.$store.commit('setMembershipReferral')
      this.$emit('membership-clicked', 'from=backlink')
    },
    addLinkedMemo(_memo) {
      this.$emit('add-linked-memo', _memo)
    },
  },
  created() {
    emitter.on('online', async () => {
      const {
        query: { memo_id },
      } = this.$route

      this.loadMemo(this.memo.slug || memo_id)
    })
  },
}
</script>
<style scoped>
div.thread {
  padding: 0 10px;
  max-width: 648px;
  max-height: 100%;
  /* overflow: auto; */
  margin: 0px 10px 20px 0;
  position: relative;
  background: (--defaultBg);
  margin: 0 auto;
}

div.thread .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  height: 52px;
  box-sizing: border-box;
}

div.thread .header h2 {
  font-weight: bold;
  font-size: 18px;
  /* color: #323232; */
}

div.thread .header .close {
  padding: 6px;
  color: grey;
  cursor: pointer;
}

div.card {
  position: relative;
  background: #ffffff;
  border-radius: 6px;
  padding: 15px;
}

.memo {
  /* padding: 10px 10px; */
}

div.related {
  color: #8f9193;
  font-size: 12px;
  padding: 0;
  cursor: pointer;
  margin-top: 6px;
}

div.related ul {
  list-style-type: none;
  padding-inline-start: 0;
  line-height: 2;
  margin: 6px 0 0;
}

div.related ul li {
  display: flex;
  align-items: center;
}

div.related ul li div.icon {
  margin-right: 6px;
  width: 12px;
  height: 12px;
  display: flex;
}

div.related ul li div.text {
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.replies {
  margin-top: 18px;
  margin-bottom: 10px;
}

.replies p {
  color: #9d9d9d;
  text-align: center;
  font-size: 12px;
}

.replies h3 {
  font-weight: bold;
  font-size: 14px;
  color: #323232;
  margin-top: 20px;
  margin-left: 10px;
}

.replies .pro {
  font-weight: normal;
  font-size: 12px;
  color: #9d9d9d;
  border: 1px solid;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 4px;
}

.replies .reply {
  margin: 10px 0;
}

div.reply div.reply-card {
  position: relative;
  background: #ffffff;
  border-radius: 6px;
  padding: 15px;
}

div.reply div.reply-card:hover {
  box-shadow: 0px 2px 10px #dddddd;
}

div.reply div.reply-card div.tools {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
}

div.reply div.reply-card:hover div.tools {
  display: block;
}

div.reply.limited {
  font-size: 14px;
  color: #8f9193;
}

div.reply.limited span {
  color: var(--tagColor);
  text-decoration: none;
  cursor: pointer;
}

.time {
  color: #8f9193;
  font-size: 12px;
  margin-bottom: 4px;
}

.content {
  color: #323232;
  font-size: 14px;
}

.content /deep/ a,
.content /deep/ a:visited {
  color: #5783f7;
  text-decoration: none;
}

.content /deep/ span.tag {
  color: var(--tagColor);
  cursor: pointer;
}

.content /deep/ ul,
.content /deep/ ol {
  padding-inline-start: 22px;
  margin: 0;
}

.content /deep/ li {
  line-height: 1;
}

.content /deep/ p {
  line-height: 1.8;
  margin: 0;
  min-height: 20px;
}

.files img {
  width: 100px;
  height: 100px;
  border: 1px solid #e6e6e6;
  cursor: pointer;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 6px;
}

blockquote.parent {
  font-size: 12px;
  color: #8f9193;
  border-left: 2px solid #e6e6e6;
  margin: 10px 0 0 0;
  padding-left: 10px;
  cursor: pointer;
}

.input-box {
  margin-top: 10px;
}
</style>
